import { createStorageBase } from './createStorageBase';
export const coreLocalStorage = createStorageBase('local');
